import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import XCloseIco from "../../../../assets/icons/XCloseIco";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import LeftRightArrowIco from "../../../../assets/icons/LeftRightArrowIco";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import { StyledFlexColumnView } from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";

function AddEditMilestone({
  openDialog,
  handleCloseDialog,
  isEdited,
  newTask,
  handleInputChange,
  handleAddTask,
}) {
  const [errors, setErrors] = useState({ from: "", to: "" });

  const validateDates = (name, value) => {
    let errorMsg = "";
    const fromDate = name === "from" ? value : newTask?.from;
    const toDate = name === "to" ? value : newTask?.to;

    if (!value || !dayjs(value).isValid()) {
      errorMsg = "Invalid date";
    } else if (fromDate && toDate && dayjs(fromDate).isAfter(dayjs(toDate))) {
      errorMsg = "From date cannot be greater than To date";
    }

    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={openDialog}
        onClose={handleCloseDialog}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            background: "#FFF",
            boxShadow:
              "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          },
        }}
      >
        <StyledSpaceBetweenBox>
          <div>
            <IconButton
              size="small"
              sx={{
                border: "1px solid #D0D5DD",
                borderRadius: "8px",
                padding: "12px",
                marginLeft: "16px",
                marginTop: "16px",
              }}
            >
              {<LeftRightArrowIco />}
            </IconButton>
          </div>
          {/* <DialogActions> */}
          <Button onClick={handleCloseDialog} sx={{ marginTop: "10px" }}>
            <XCloseIco />
          </Button>
          {/* </DialogActions> */}
        </StyledSpaceBetweenBox>
        <DialogTitle>
          <Typography variant="h3" sx={{ mt: 2 }}>
            {/* {isEdited ? "Edit Note" : "Create Note"} */}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Grid2 spacing={2} container>
            <Grid2 size={12}>
              <Typography variant="h2" color="#101828">
                {isEdited ? "Edit Task" : "Add New Task"}
              </Typography>
            </Grid2>
            <Grid2 size={12}>
              <StyledFlexColumnView>
                <Typography
                  fontWeight={500}
                  fontSize={"16px"}
                  color={"#344054"}
                >
                  {"Milestone"}
                </Typography>
                <CommonTextField
                  fullWidth
                  placeholder="Enter Milestone"
                  value={newTask?.title || ""}
                  onChange={(e) => handleInputChange("title", e.target.value)}
                  padding={"12px"}
                />
              </StyledFlexColumnView>
            </Grid2>
            <Grid2 size={12}>
              <StyledFlexColumnView>
                <Typography variant="body2">From</Typography>
                <DatePicker
                  label=""
                  //   value={newTask?.from}
                  value={newTask?.from ? dayjs(newTask.from) : null}
                  onChange={(newValue) => {
                    handleInputChange("from", newValue);
                    validateDates("from", newValue);
                  }}
                  // onChange={(newValue) => handleInputChange("from", newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      error={!!errors.from}
                      helperText={errors.from}
                      placeholder="Select date"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <CalendarTodayIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  )}
                />
                <Typography sx={{ color: "red" }}>{errors.from}</Typography>
              </StyledFlexColumnView>
            </Grid2>

            <Grid2 size={12}>
              <StyledFlexColumnView>
                <Typography variant="body2">To</Typography>
                <DatePicker
                  label=""
                  //   value={newTask?.to}
                  value={newTask?.to ? dayjs(newTask.to) : null}
                  onChange={(newValue) => {
                    handleInputChange("to", newValue);
                    validateDates("to", newValue);
                  }}
                  // onChange={(newValue) => handleInputChange("to", newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      error={!!errors.to}
                      helperText={errors.to}
                      placeholder="Select date"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <CalendarTodayIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  )}
                />
                <Typography sx={{ color: "red" }}>{errors.to}</Typography>
              </StyledFlexColumnView>
            </Grid2>

            <Grid2 size={12}>
              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                value={isEdited ? "Edit Milestone" : "Add Milestone"}
                padding="8px 20px"
                fullWidth
                disabled={!!errors.from || !!errors.to}
                onClick={handleAddTask}
              />
            </Grid2>
          </Grid2>
        </DialogContent>
      </Dialog>
    </LocalizationProvider>
  );
}

export default AddEditMilestone;
